import { render, staticRenderFns } from "./COM_MenuRight.vue?vue&type=template&id=6f240f0f&scoped=true&"
import script from "./COM_MenuRight.vue?vue&type=script&lang=js&"
export * from "./COM_MenuRight.vue?vue&type=script&lang=js&"
import style0 from "./COM_MenuRight.vue?vue&type=style&index=0&id=6f240f0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f240f0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f240f0f')) {
      api.createRecord('6f240f0f', component.options)
    } else {
      api.reload('6f240f0f', component.options)
    }
    module.hot.accept("./COM_MenuRight.vue?vue&type=template&id=6f240f0f&scoped=true&", function () {
      api.rerender('6f240f0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/components/COM_MenuRight.vue"
export default component.exports